import React from "react";
import { PickerEntry } from "../../generic-components/PickerEntry";
import { UnitOfMeasure } from "../../pace-fns/pace-fns";
import { validateUnitOfMeasureField } from "./controlUtility";

const UnitOfMeasureFieldName = "Unit";
const UnitOfMeasureOptions = [
  UnitOfMeasure.MILE,
  UnitOfMeasure.KILOMETER,
  UnitOfMeasure.METER
];

type UOMControlProps = {
  value: UnitOfMeasure;
  onChange(unitOfMeasure: UnitOfMeasure | undefined): void;
};
export const UnitOfMeasureControl = ({
  value,
  onChange
}: UOMControlProps) => {
  const onUnitOfMeasureChange = (newUnitValue: string) => {
    if (validateUnitOfMeasureField(newUnitValue)) {
      const unitOfMeasure = newUnitValue as UnitOfMeasure;
      onChange(unitOfMeasure);
    } else {
      onChange(undefined);
    }
  };

  return (
    <PickerEntry
      fieldName={UnitOfMeasureFieldName}
      onFieldChange={onUnitOfMeasureChange}
      options={UnitOfMeasureOptions}
      value={value}
    />
  );
};
